import React from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  OptionProps,
} from 'react-select';
import { SelectOption } from '@lib/components/Select/types';
import AvatarIcon from '@lib/assets/icons/avatar.svg?react';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import styles from '../Select.module.scss';

function UserOption({
  children,
  ...restProps
}: OptionProps): React.ReactElement {
  const { isSelected, isMulti, options } = restProps;
  const value = _get(restProps, 'value', '');
  const selectedOption = _find(
    options,
    ({ value: optionValue }) => value === optionValue,
  ) as SelectOption;
  const { data } = selectedOption || {};
  const email = _get(data, 'email');
  const url =
    _get(data, 'avatarAttached.urls.small') ||
    _get(data, 'avatarAttached.urls.original');
  return (
    // @ts-ignore
    <DefaultSelectComponents.Option
      {...restProps}
      className={classNames(styles.userOption, {
        active: isSelected,
        [styles.optionWithCheckbox]: isMulti,
      })}
    >
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.userOptionIcon}>
        {url ? <img src={url} alt="" /> : <AvatarIcon />}
      </span>
      <div>
        {children}
        {email && (
          <Typography variant="caption" className={styles.userOptionEmail}>
            {email}
          </Typography>
        )}
      </div>
    </DefaultSelectComponents.Option>
  );
}

export default UserOption;
